export const getBreakpoint = (breakpoint: number) =>
  `(min-width: ${breakpoint.toString()}px)`;
